import * as actionTypes from "../actions/actionTypes";

const intialState = {
  isLoading: false,
  error: "",
  getRemitterDetailsForDMTV2: "",
};

const getRemitterDetailsForDMTV2Start = (state) => {
  return {
    ...state,
    isLoading: true,
    getRemitterDetailsForDMTV2: "",
    error: "",
  };
};

const getRemitterDetailsForDMTV2Success = (state, data) => {
  return {
    ...state,
    getRemitterDetailsForDMTV2: data,
    isLoading: false,
    error: "",
  };
};

const getRemitterDetailsForDMTV2Fail = (state, err) => {
  return {
    ...state,
    error: err,
    isLoading: false,
  };
};

const resetDmtV2Func = (state) => {
  return {
    ...state,
    isLoading: false,
    error: "",
    getRemitterDetailsForDMTV2: "",
  };
};

const DmtV2Reducer = (state = intialState, action) => {
  switch (action.type) {
    case actionTypes.GET_REMITTER_DETAILS_FOR_DMTV2_START:
      return getRemitterDetailsForDMTV2Start(state);
    case actionTypes.GET_REMITTER_DETAILS_FOR_DMTV2_SUCCESS:
      return getRemitterDetailsForDMTV2Success(state, action.data);
    case actionTypes.GET_REMITTER_DETAILS_FOR_DMTV2_FAIL:
      return getRemitterDetailsForDMTV2Fail(state, action.err);

    case actionTypes.RESET_DMTV2_START:
      return resetDmtV2Func(state);

    default:
      return state;
  }
};

export default DmtV2Reducer;
